import React, {useEffect} from 'react';
import {Button, Card, Spin} from "antd";
import Descriptions from "antd/lib/descriptions";
import {fetchExportedOrgData} from "../../appRedux/actions";

function DataManage({loading, exportOrgData, fetchExportedOrgData, exportedData}) {

  useEffect(() => {
    fetchExportedOrgData();
  }, []);

  useEffect(() => {
    // console.log(exportedData);

  }, [fetchExportedOrgData, exportedData]);

  const handleExportClick = (e) => {
    e.preventDefault();
    exportOrgData();
  }

  const handleRefreshClick = (e) => {
    e.preventDefault();
    fetchExportedOrgData();
  }

  const handleDownloadFile = async (e, url) => {
    e.preventDefault();
    // console.log(url);
    if (url) {
      const response = await fetch(url);
      const blob = await response.blob();
      const objectUrl = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = objectUrl;
      // link.download = 'downloaded-file.txt'; // Specify the desired file name
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(objectUrl);
    }
  }

  return (
    <Spin spinning={loading}>
      <Card className={`gx-card-metrics`} title={`Organisation Data Manager`}>
        <Button icon={'download'} onClick={handleExportClick} type={'primary'}>Export</Button>
        <Button icon={'sync'} loading={loading} onClick={handleRefreshClick} style={{float: 'right'}}>Refresh</Button>

        <br/><br/>
        {exportedData && exportedData.url &&
          <Descriptions
            title="Download Data"
            bordered
            column={{xxl: 4, xl: 3, lg: 3, md: 3, sm: 2, xs: 1}}
          >
            <Descriptions.Item label="File">Organisation Data</Descriptions.Item>
            <Descriptions.Item label="Reqused By">{exportedData.by || ''}</Descriptions.Item>
            <Descriptions.Item label="Time">Automatically deleted after 15 minute</Descriptions.Item>
            <Descriptions.Item label=""><Button type={"primary"} icon={'download'}
                                                onClick={(e) => handleDownloadFile(e, exportedData.url)}>Download</Button></Descriptions.Item>
          </Descriptions>
        }
      </Card>
    </Spin>
  );
}

export default DataManage;
